import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import {
  Box,
  Checkbox,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ErrorToolTipIcon from "../../CatalogBulkUploadNewCopy/Components/ErrorToolTipIcon";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import {
  blackColor,
  blackShade05,
  blackShade19,
  blackShade23,
  borderTextBoxColor,
  greenColor,
  greyColor42,
  greyColor47,
  greyColor8,
  lightRedColor,
  redColor,
  tableHeaderColor,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { ALL_STOCK_COLUMN_HEADER_CHILD_VARIANT } from "../../../utils/data";
import TabelCellInputBox from "../../../components/TableInputs/TabelCellInputBox";
import TableCellSwitchBtn from "../../../components/TableInputs/TableCellSwitchBtn";
import TableCellDropdownBox from "../../../components/TableInputs/TableCellDropdownBox";
import TableCellDateInputBox from "../../../components/TableInputs/TableCellDateInputBox";
import { getVariantValues } from "../../../utils/validateAndPrepareVariant";
import { toTitleCase } from "../../../utils/validationUtils";
import { textOneLines } from "../../../utils/styles";

function NotSellingChildProductList({
  products,
  tableHeader,
  handleInputChange,
  name,
  isCatalogPartner,
  catalogPartner
}) {
  const { gstRates } = useSelector((state) => state.catalog);

  return (
    <Box>
      <Typography
        fontSize={13}
        fontWeight={600}
        lineHeight={1.5}
        color={blackShade23}
        py={"5px"}
      >
        {name}
      </Typography>
      <Box sx={styles.tableWrapper}>
        <TableContainer sx={styles.tableContainer} component={Box}>
          <Table aria-label="simple table" size="small">
            <TableHead borderBottom={`1px solid ${tableHeaderColor}`}>
              <TableRow
                sx={{
                  position: "sticky !important",
                  top: 0,
                  backgroundColor: whiteColor,
                  zIndex: 20,
                  borderBottom: `1px solid ${tableHeaderColor}`,
                  borderRadius: "8px 8px 0 0",
                }}
              >
                <TableCell
                  sx={{
                    ...styles.tableCell,
                    ...styles.colSticky,
                  }}
                >
                  <Box display={"inline-block"} alignItems="center" gap={1.2}>
                    <Checkbox
                      //   checked={allStockUpdateProducts?.every(
                      //     (item) => item.itemChange
                      //   )}
                      checked={false}
                      onChange={({ target }) => {
                        // selectAllRows();
                      }}
                      sx={styles.checkbox}
                    />
                  </Box>
                </TableCell>
                {tableHeader?.map((item, index) => {
                  // const selectedRows = getSelectedInventoryRowCount(
                  //   allStockUpdateProducts
                  // );

                  return (
                    <TableCell
                      key={item.title}
                      sx={{
                        ...styles.tableCell,
                        ...styles.colSticky,
                      }}
                    >
                      <Box
                        display={index === 0 ? "flex" : "inline-block"}
                        alignItems="center"
                        gap={1.2}
                      >
                        {/* {index === 0 && (
                          <Checkbox
                            //   checked={allStockUpdateProducts?.every(
                            //     (item) => item.itemChange
                            //   )}
                            checked={false}
                            onChange={({ target }) => {
                              // selectAllRows();
                            }}
                            sx={styles.checkbox}
                          />
                        )} */}
                        <Box sx={{ fontSize: 12, textTransform: "uppercase" }}>
                          {item?.title}{" "}
                        </Box>
                      </Box>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody sx={{ backgroundColor: whiteColor }}>
              {products?.map((productInfo, index) => {
                const data = getVariantValues(productInfo);
                return (
                  <TableRow
                    key={`All_Stock_${index}`}
                    sx={{
                      borderBottom: `1px solid ${borderTextBoxColor}`,
                      verticalAlign: "top",
                    }}
                  >
                    {/* <TableCell
                      sx={{
                        ...styles.tableStickyLeftCell,
                      }}
                    >
                      <Box display="flex" alignItems="flex-start" gap={1.2}>
                        <Checkbox
                          sx={{ ...styles.checkbox, mt: 1 }}
                          checked={productInfo?.itemChange || false}
                          onChange={() => {
                            handleInputChange(
                              {
                                type: "itemChange",
                                value: !productInfo?.itemChange,
                              },
                              index
                            );
                          }}
                        />
                        <Box display="flex" gap={1.5}>
                          <Box width="33px">
                            <Box
                              component="img"
                              src={productInfo?.productPhoto?.[0]?.docURL}
                              sx={styles.imgContainer}
                            />
                          </Box>
  
                          <Box flex={1}>
                            <Typography
                              variant="body1"
                              title={productInfo?.productName}
                              sx={{
                                ...styles.prodNameBox,
                                ...textOneLines,
                              }}
                            >
                              {productInfo?.productName}
                            </Typography>
  
                            <Box display="flex" alignItems="center" gap={1}>
                              <Typography
                                fontSize={11}
                                color={blackShade21}
                                sx={{
                                  textDecoration: "line-through",
                                }}
                              >
                                ₹ {productInfo?.productOriginalPrice}
                              </Typography>
  
                              <Typography
                                fontSize={12}
                                fontWeight={600}
                                color={blueColor04}
                              >
                                ₹ {productInfo?.productSalePrice}
                              </Typography>
  
                              <Box sx={styles.percentageOffTag}>
                                {productInfo?.percentageOff} %
                              </Box>
  
                              <Typography
                                fontSize={11.5}
                                fontWeight={400}
                                color={greyColor40}
                              >
                                ONDC Enabled :{" "}
                                <span
                                  style={{
                                    fontSize: 11,
                                    fontWeight: 600,
                                    color:
                                      productInfo?.ondcEnabled?.toLowerCase() ===
                                      "yes"
                                        ? copyBtnColor
                                        : outOfStockColor,
                                  }}
                                >
                                  {toTitleCase(productInfo?.ondcEnabled || "No")}
                                </span>
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </TableCell> */}
                    <TableCell sx={styles.tableStickyLeftCell}>
                      <Checkbox
                        sx={{ ...styles.checkbox }}
                        checked={productInfo?.itemChange || false}
                        onChange={() => {
                          handleInputChange(
                            {
                              type: "itemChange",
                              value: !productInfo?.itemChange,
                            },
                            index
                          );
                        }}
                      />
                    </TableCell>
                    {data?.variant1 && (
                      <TableCell sx={styles.tableBodyCell(false)}>
                        <Box display="flex" alignItems="center" gap={1.2}>
                          {/* <Checkbox
                            sx={{ ...styles.checkbox }}
                            checked={productInfo?.itemChange || false}
                            onChange={() => {
                              handleInputChange(
                                {
                                  type: "itemChange",
                                  value: !productInfo?.itemChange,
                                },
                                index
                              );
                            }}
                          /> */}
                          <Typography
                            fontSize={12}
                            fontWeight={500}
                            color={blackColor}
                          >
                            {toTitleCase(data?.variant1)}
                          </Typography>
                        </Box>
                      </TableCell>
                    )}
                    {data?.variant2 && (
                      <TableCell sx={styles.tableBodyCell(false)}>
                        <Typography
                          fontSize={12}
                          fontWeight={500}
                          color={blackColor}
                        >
                          {toTitleCase(data?.variant2)}
                        </Typography>
                      </TableCell>
                    )}
                    {data?.variant3 && (
                      <TableCell sx={styles.tableBodyCell(false)}>
                        <Typography
                          fontSize={12}
                          fontWeight={500}
                          color={blackColor}
                        >
                          {toTitleCase(data?.variant3)}
                        </Typography>
                      </TableCell>
                    )}

                    <TableCell sx={styles.tableBodyCell(false)}>
                      <TableCellSwitchBtn
                        value={productInfo?.availability?.[0] == "Yes"}
                        onValueChange={(value) => {
                          if (value) {
                            handleInputChange(
                              {
                                type: "availability",
                                value: ["Yes"],
                              },
                              index
                            );
                          } else {
                            handleInputChange(
                              {
                                type: "availability",
                                value: ["No"],
                              },
                              index
                            );
                          }
                        }}
                        errorMsg={productInfo?.errors?.availability}
                      />
                    </TableCell>

                    <TableCell sx={styles.tableBodyCell(false)}>
                      {isCatalogPartner ? (
                        <Typography
                          fontSize={12}
                          fontWeight={400}
                          color={blackShade19}
                          sx={{ ...textOneLines }}
                        >
                          Refer {catalogPartner || "Catalog Partner"}
                        </Typography>
                      ) : (
                        <TabelCellInputBox
                          minWidth={"60px"}
                          value={productInfo?.availableQuantity}
                          onValueChange={(value) => {
                            handleInputChange(
                              {
                                type: "availableQuantity",
                                value,
                              },
                              index
                            );
                          }}
                          regexType="qty"
                          disabled={productInfo?.availability?.[0] == "No"}
                          errorMsg={productInfo?.errors?.availableQuantity}
                          errorPositionRight
                        />
                      )}
                    </TableCell>

                    <TableCell sx={styles.tableBodyCell(false)}>
                      <TabelCellInputBox
                        minWidth={"60px"}
                        value={productInfo?.alertQuantity}
                        onValueChange={(value) => {
                          handleInputChange(
                            {
                              type: "alertQuantity",
                              value,
                            },
                            index
                          );
                        }}
                        regexType="qty"
                        disabled={productInfo?.availability?.[0] == "No"}
                        errorMsg={productInfo?.errors?.alertQuantity}
                      />
                    </TableCell>

                    <TableCell sx={styles.tableBodyCell(false)}>
                      <TabelCellInputBox
                        minWidth={"60px"}
                        value={productInfo?.minOrderQuantity}
                        onValueChange={(value) => {
                          handleInputChange(
                            {
                              type: "minOrderQuantity",
                              value,
                            },
                            index
                          );
                        }}
                        regexType="qty"
                        disabled={productInfo?.availability?.[0] == "No"}
                        errorMsg={productInfo?.errors?.minOrderQuantity}
                      />
                    </TableCell>

                    <TableCell sx={styles.tableBodyCell(false)}>
                      <TabelCellInputBox
                        minWidth={"60px"}
                        value={productInfo?.maxOrderQuantity}
                        onValueChange={(value) => {
                          handleInputChange(
                            {
                              type: "maxOrderQuantity",
                              value,
                            },
                            index
                          );
                        }}
                        regexType="qty"
                        disabled={productInfo?.availability?.[0] == "No"}
                        errorMsg={productInfo?.errors?.maxOrderQuantity}
                      />
                    </TableCell>

                    <TableCell sx={styles.tableBodyCell(false)}>
                      <TabelCellInputBox
                        value={productInfo?.productOriginalPrice}
                        onValueChange={(value) => {
                          handleInputChange(
                            {
                              type: "productOriginalPrice",
                              value,
                            },
                            index
                          );
                        }}
                        regexType="price"
                        startIcon="₹"
                        disabled={productInfo?.availability?.[0] == "No"}
                        errorMsg={productInfo?.errors?.productOriginalPrice}
                      />
                    </TableCell>

                    <TableCell sx={styles.tableBodyCell(false)}>
                      <TabelCellInputBox
                        value={productInfo?.priceOff}
                        onValueChange={(value) => {
                          handleInputChange(
                            {
                              type: "priceOff",
                              value,
                            },
                            index
                          );
                        }}
                        regexType="number"
                        minWidth="50px"
                        maxLength={2}
                        disabled={productInfo?.availability?.[0] == "No"}
                      />
                    </TableCell>

                    <TableCell sx={styles.tableBodyCell(false)}>
                      <TabelCellInputBox
                        value={productInfo?.productSalePrice}
                        onValueChange={(value) => {
                          handleInputChange(
                            {
                              type: "productSalePrice",
                              value,
                            },
                            index
                          );
                        }}
                        regexType="price"
                        startIcon="₹"
                        disabled={productInfo?.availability?.[0] == "No"}
                        errorMsg={productInfo?.errors?.productSalePrice}
                      />
                    </TableCell>

                    <TableCell
                      sx={styles.tableBodyCell(
                        productInfo?.errors?.gstPercentage
                      )}
                    >
                      <TableCellDropdownBox
                        width="100px"
                        value={
                          productInfo?.gstInfo?.gstPercentage || "Select GST %"
                        }
                        onValueChange={(value) => {
                          handleInputChange(
                            {
                              type: "gstInfo",
                              value: {
                                code: productInfo?.gstInfo?.code,
                                gstPercentage: value,
                              },
                            },
                            index
                          );
                        }}
                        menuList={[{ value: "Select GST %" }, ...gstRates]}
                        valueSelector="value"
                        borderFull
                        disabled={productInfo?.availability?.[0] == "No"}
                        errorMsg={productInfo?.errors?.gstPercentage}
                      />
                    </TableCell>

                    <TableCell sx={styles.tableBodyCell(false)}>
                      <TableCellDateInputBox
                        value={moment(productInfo?.commerceStartDate)?.format(
                          "YYYY-MM-DD"
                        )}
                        onValueChange={(value) => {
                          console.log("HITTITITIT___:", value);
                          handleInputChange(
                            {
                              type: "commerceStartDate",
                              value: value,
                            },
                            index
                          );
                        }}
                        disabled={productInfo?.availability?.[0] == "No"}
                        errorMsg={productInfo?.errors?.commerceStartDate}
                      />
                    </TableCell>

                    <TableCell sx={styles.tableBodyCell(false)}>
                      <TabelCellInputBox
                        value={productInfo?.validityDays}
                        onValueChange={(value) => {
                          handleInputChange(
                            {
                              type: "validityDays",
                              value,
                            },
                            index
                          );
                        }}
                        regexType="number"
                        maxLength={4}
                        disabled={productInfo?.availability?.[0] == "No"}
                        errorMsg={productInfo?.errors?.validityDays}
                      />
                    </TableCell>

                    <TableCell sx={styles.tableBodyCell(false)}>
                      <TableCellDateInputBox
                        value={moment(productInfo?.commerceEndDate)?.format(
                          "YYYY-MM-DD"
                        )}
                        onValueChange={(value) => {
                          handleInputChange(
                            {
                              type: "commerceEndDate",
                              value: value,
                            },
                            index
                          );
                        }}
                        disabled={productInfo?.availability?.[0] == "No"}
                        errorMsg={productInfo?.errors?.commerceEndDate}
                      />
                    </TableCell>

                    <TableCell sx={styles.tableStickyRightCell}>
                      <Box
                        minWidth="50px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1.5}
                      >
                        <Stack alignItems="center" justifyContent="center">
                          {productInfo?.errors &&
                          Object.keys(productInfo?.errors).length > 0 ? (
                            <Box sx={styles.errorCountTag}>
                              <Box
                                sx={{
                                  position: "absolute",
                                  right: -6,
                                  top: -6,
                                }}
                              >
                                <ErrorToolTipIcon errorMsg="Please review all columns for errors" />
                              </Box>
                              {Object.keys(productInfo?.errors).length}
                            </Box>
                          ) : (
                            <CheckCircleIcon
                              sx={{
                                fontSize: 16,
                                color: greenColor,
                              }}
                            />
                          )}
                        </Stack>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}

export default NotSellingChildProductList;

const styles = {
  tableWrapper: {
    width: "100%",
    borderRadius: "6px",
    border: `1px solid ${borderTextBoxColor}`,
    // overflowX: "scroll",
    bgColor: whiteColor,
  },
  tableContainer: {
    borderRadius: "8px",
    overflow: "scroll",
    maxHeight: "calc(100vh - 330px)",

    "&::-webkit-scrollbar": {
      width: "4px",
      height: "4px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: "rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },

  tableCell: {
    color: greyColor47,
    fontSize: "12.5px",
    fontWeight: "500",
    whiteSpace: "nowrap",
    padding: "8px 15px",
    backgroundColor: greyColor42,
    borderRight: `1px solid ${whiteColor}`,
  },
  tableBodyCell: (isError) => ({
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: blackShade05,
    backgroundColor: isError ? lightRedColor : whiteColor,
    padding: "8px 15px !important",
    borderRight: `1px solid ${borderTextBoxColor}`,

    boxShadow: isError ? `0px -1px 0 0 ${redColor} inset` : "none",
  }),

  checkbox: {
    p: 0,
    transform: "scale(1.2)",
    "&.Mui-checked": {
      color: greyColor8,
    },
  },

  errorCountTag: {
    backgroundColor: lightRedColor,
    color: redColor,
    fontSize: 12,
    fontWeight: 600,
    p: "3px 18px",
    borderRadius: "10px",
  },
  colSticky: {
    ":first-child": { position: "sticky", left: "0px" },
    ":last-child": { position: "sticky", right: "-3px" },
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset`,
  },

  tableStickyLeftCell: {
    minWidth: "50px !important",
    maxWidth: "50px !important",
    backgroundColor: whiteColor,
    padding: "10px 15px !important",
    borderRight: `1px solid ${borderTextBoxColor}`,
    position: "sticky",
    left: 0,
    zIndex: 10,
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset`,
  },

  tableStickyRightCell: {
    position: "sticky",
    right: 0,
    backgroundColor: whiteColor,
    zIndex: 10,
    boxShadow: `1px 0 0 0 ${borderTextBoxColor} inset`,
  },
};
